import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

/**
 * Composant pour protéger les routes qui nécessitent une authentification
 * @param {Object} props - Les propriétés du composant
 * @param {boolean} props.adminOnly - Si la route est réservée aux administrateurs
 * @param {React.ReactNode} props.children - Les composants enfants à rendre si l'utilisateur est authentifié
 */
const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user, isAuthenticated, loading } = useContext(AuthContext);
  
  // Afficher un indicateur de chargement pendant la vérification de l'authentification
  if (loading) {
    return <div>Chargement...</div>;
  }
  
  // Rediriger vers la page de connexion si non authentifié
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // Vérifier le rôle si la route est réservée aux administrateurs
  if (adminOnly && !['ADMIN', 'MANAGER'].includes(user.role)) {
    return <Navigate to="/" />;
  }
  
  // Rendre les composants enfants si l'utilisateur est authentifié et a les permissions nécessaires
  return children;
};

export default PrivateRoute; 